import React from "react";
import { Typography } from "@mui/material";

import FooterButtons from "./FooterButtons";
import SimplePaper from "../components/SimplePaper";

const PrivacyPolicy = () => {
  const title = "Privacy Policy";

  const body = (
    <>
      <Typography variant="body1" paragraph>
        At AstroData, we are committed to protecting your privacy. This privacy
        policy outlines how we collect, use, and safeguard your information when
        you use our website and services.
      </Typography>

      <Typography variant="h4" gutterBottom>
        1. Information We Collect
      </Typography>
      <Typography variant="body1" paragraph>
        We may collect personal information that you provide to us when you
        register on our site, subscribe to our newsletter, fill out a form, or
        use other services provided by our website. This may include your name,
        email address, phone number, birth details, and other personal
        information. We also collect information about your interactions with
        our site and services, including IP addresses, browser type, and access
        times.
      </Typography>
      <Typography variant="body1" paragraph>
        Additionally, we may collect information through cookies and similar
        technologies to enhance your experience on our site. Cookies are small
        files that a site or its service provider transfers to your computer's
        hard drive through your web browser (if you allow) that enables the
        site's or service provider's systems to recognize your browser and
        capture and remember certain information.
      </Typography>

      <Typography variant="h4" gutterBottom>
        2. How We Use Your Information
      </Typography>
      <Typography variant="body1" paragraph>
        The information we collect from you may be used in the following ways:
      </Typography>
      <Typography variant="body1" paragraph>
        - To personalize your experience and respond better to your individual
        needs.
        <br />
        - To improve our website based on the information and feedback we
        receive from you.
        <br />
        - To send periodic emails and messages with updates, information, and
        promotions.
        <br />
        - To process transactions and provide the services you requested.
        <br />
        - To communicate with you via WhatsApp and other messaging services for
        customer support and service updates.
        <br />
        - To administer a contest, promotion, survey, or other site feature.
        <br />- To comply with legal obligations and enforce our site policies.
      </Typography>

      <Typography variant="h4" gutterBottom>
        3. How We Protect Your Information
      </Typography>
      <Typography variant="body1" paragraph>
        We implement a variety of security measures to maintain the safety of
        your personal information. These measures include secure servers, data
        encryption, and regular security audits. We ensure that your personal
        information is accessible only by authorized personnel and is handled
        with the utmost care. Despite these measures, please be aware that no
        security measures are perfect or impenetrable, and we cannot guarantee
        absolute security.
      </Typography>

      <Typography variant="h4" gutterBottom>
        4. Cookies and Similar Technologies
      </Typography>
      <Typography variant="body1" paragraph>
        Our website may use cookies to enhance your experience. Cookies are
        small files that a site or its service provider transfers to your
        computer's hard drive through your web browser (if you allow) that
        enables the site's or service provider's systems to recognize your
        browser and capture and remember certain information. You can choose to
        disable cookies through your browser settings, but this may affect your
        ability to use some features of our site.
      </Typography>
      <Typography variant="body1" paragraph>
        We may also use web beacons, tracking pixels, and other tracking
        technologies to monitor how you interact with our site, which helps us
        to improve our services and user experience.
      </Typography>

      <Typography variant="h4" gutterBottom>
        5. Third-Party Disclosure
      </Typography>
      <Typography variant="body1" paragraph>
        We do not sell, trade, or otherwise transfer to outside parties your
        personally identifiable information. This does not include trusted third
        parties who assist us in operating our website, conducting our business,
        or servicing you, so long as those parties agree to keep this
        information confidential. We may also release your information when we
        believe release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others' rights, property, or safety.
      </Typography>
      <Typography variant="body1" paragraph>
        We may share non-personally identifiable visitor information with third
        parties for marketing, advertising, or other uses.
      </Typography>

      <Typography variant="h4" gutterBottom>
        6. Use of WhatsApp and Other Messaging Services
      </Typography>
      <Typography variant="body1" paragraph>
        We may use WhatsApp and other messaging services to communicate with you
        for customer support, service updates, and promotional purposes. By
        providing your phone number, you consent to receive messages from us via
        these services. Standard messaging rates may apply. You can opt-out of
        receiving messages by contacting us or following the instructions
        provided in the message.
      </Typography>
      <Typography variant="body1" paragraph>
        We ensure that any data shared with WhatsApp or similar services is
        handled in compliance with their privacy policies and terms of service.
      </Typography>

      <Typography variant="h4" gutterBottom>
        7. Your Rights and Choices
      </Typography>
      <Typography variant="body1" paragraph>
        You have the right to access, correct, or delete your personal
        information held by us. You can also object to or restrict the
        processing of your data. To exercise these rights, please contact us at
        support@astrodata.app. We will respond to your request in accordance
        with applicable data protection laws.
      </Typography>

      <Typography variant="h4" gutterBottom>
        8. Your Consent
      </Typography>
      <Typography variant="body1" paragraph>
        By using our site and services, you consent to our privacy policy. If
        you do not agree with our policies and practices, you may choose not to
        use our site and services.
      </Typography>

      <Typography variant="h4" gutterBottom>
        9. Changes to Our Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        AstroData reserves the right to update or change our privacy policy at
        any time. Any changes will be posted on this page, and the date of the
        latest revision will be indicated at the top of the page. Your continued
        use of our site and services after any changes constitute your
        acceptance of the new privacy policy.
      </Typography>

      <Typography variant="body1" paragraph>
        If you have any questions about this privacy policy, please contact us
        at support@astrodata.app
      </Typography>
    </>
  );

  return (
    <>
      <SimplePaper title={title} body={body} />

      <FooterButtons />
    </>
  );
};

export default PrivacyPolicy;
